export const isAdminPath = (): boolean => window.location.pathname.includes('admin');
